(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/child-components/draw-card.net-sale.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/child-components/draw-card.net-sale.js');
"use strict";


const CurrencyCounter = svs.components.lbUi.currencyCounter.CurrencyCounter;
const DrawCardNetSale = _ref => {
  let _ref$children = _ref.children,
    children = _ref$children === void 0 ? 0 : _ref$children,
    currencyCounterUniqueId = _ref.currencyCounterUniqueId,
    hasHiddenAria = _ref.hasHiddenAria;
  return React.createElement("div", {
    "aria-hidden": Boolean(hasHiddenAria),
    className: "pg_draw_card__net_sale pg_draw_card_component"
  }, React.createElement(CurrencyCounter, {
    amount: children,
    uniqueId: currencyCounterUniqueId
  }), ' kr');
};
setGlobal('svs.components.tipsen.drawCardComponents.DrawCardNetSale', DrawCardNetSale);

 })(window);